import React, {useEffect, useState} from 'react'
import styles from './boxFlotante.module.css'
import Btn from '../btn/Btn'
import secure from '../boxFlotante/img/secure.png'

const BoxFlotante = ({setMuestra, muestra}) => {
    
    return ( 
       <div className={`${muestra ? styles.containerNone : styles.container }`}>
              <div className={styles.contenedor}>  
                     <Btn 
                        texto="Habla Con Un Especialista"
                        setMuestra={setMuestra}
                        />
              </div>
       </div>
     );
}


export default BoxFlotante;